/*
swipe.js
This module contains swipe gesture detection (touch/mouse handling),
the reaction trigger via swipe, and the associated animation.
*/

export function initSwipe(config) {
    // Attach swipe listeners to all existing feed media wrappers
    const mediaWrappers = document.querySelectorAll('.feed-item .feed-media-wrapper');
    mediaWrappers.forEach((wrapper) => {
      const feedItem = wrapper.closest('.feed-item');
      if (feedItem) {
        const ratingId = feedItem.getAttribute('data-rating-id');
        addSwipeListener(wrapper, ratingId, config);
      }
    });
  }
  
  const userReactions = {};
  
  export function addSwipeListener(mediaWrapper, ratingId, config) {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let isSwiping = false;
    let mouseDown = false;
  
    mediaWrapper.addEventListener('touchstart', handleTouchStart, false);
    mediaWrapper.addEventListener('touchmove', handleTouchMove, false);
    mediaWrapper.addEventListener('touchend', handleTouchEnd, false);
  
    mediaWrapper.addEventListener('mousedown', (e) => {
      mouseDown = true;
      touchStartX = e.clientX;
      touchStartY = e.clientY;
    }, false);
  
    mediaWrapper.addEventListener('mousemove', (e) => {
      if (!mouseDown) return;
      touchEndX = e.clientX;
      touchEndY = e.clientY;
      isSwiping = true;
    }, false);
  
    mediaWrapper.addEventListener('mouseup', () => {
      if (isSwiping) {
        handleSwipe();
      }
      mouseDown = false;
      isSwiping = false;
    }, false);
  
    function handleTouchStart(e) {
      touchEndX = 0;
      touchEndY = 0;
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
      isSwiping = true;
    }
  
    function handleTouchMove(e) {
      if (!isSwiping) return;
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
    }
  
    function handleTouchEnd(e) {
      if (!isSwiping) return;
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe();
      isSwiping = false;
    }
  
    function handleSwipe() {
      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;
      const swipeThreshold = 50; // Minimum distance for a swipe
      const swipeAngle = Math.atan2(Math.abs(deltaY), Math.abs(deltaX)) * (180 / Math.PI);
  
      if (Math.abs(deltaX) < swipeThreshold || swipeAngle > 30) {
        // Not a valid horizontal swipe
        return;
      }
  
      if (deltaX > 0) {
        triggerSwipeReaction(ratingId, 'like', mediaWrapper, config);
      } else {
        triggerSwipeReaction(ratingId, 'dislike', mediaWrapper, config);
      }
    }
  }
  
  export async function triggerSwipeReaction(ratingId, action, mediaWrapper, config) {
    if (userReactions[ratingId] === action) {
      window.showToast(`You have already ${action}d this.`, 'warning');
      return;
    }
  
    const emoji = action === 'like' ? '👍' : '👎';
    const reactionClass = action === 'like' ? 'like-overlay' : 'dislike-overlay';
  
    const reactionOverlay = mediaWrapper.querySelector('.reaction-overlay');
    reactionOverlay.textContent = emoji;
    reactionOverlay.classList.add('show', reactionClass);
  
    animateReaction(mediaWrapper, emoji);
  
    setTimeout(() => {
      reactionOverlay.classList.remove('show', reactionClass);
      reactionOverlay.textContent = '';
    }, 1500);
  
    try {
      const response = await fetch(`/feed/${ratingId}/swipe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': config.csrfToken,
        },
        body: JSON.stringify({ action }),
      });
      if (response && response.ok) {
        const data = await response.json();
        if (data.success) {
          window.showToast(`You ${action}d this rating.`, 'success');
          userReactions[ratingId] = action;
        } else {
          if (data.error) {
            if (data.error.toLowerCase().includes('already liked')) {
              window.showToast('You have already liked this.', 'warning');
            } else if (data.error.toLowerCase().includes('already disliked')) {
              window.showToast('You have already disliked this.', 'warning');
            } else {
              window.showToast(data.error || 'Could not perform reaction.', 'danger');
            }
          } else {
            window.showToast('Could not perform reaction.', 'danger');
          }
        }
      } else {
        window.showToast('Failed to perform reaction.', 'danger');
      }
    } catch (error) {
      console.error('Error performing reaction:', error);
      window.showToast('Error performing reaction.', 'danger');
    }
  }
  
  export function animateReaction(mediaWrapper, emoji) {
    const animationContainer = document.createElement('div');
    animationContainer.classList.add('reaction-emoji-container');
    mediaWrapper.appendChild(animationContainer);
  
    const particleCount = 20;
    for (let i = 0; i < particleCount; i++) {
      const reactionEmoji = document.createElement('span');
      reactionEmoji.classList.add('reaction-emoji-particle');
      reactionEmoji.textContent = emoji;
  
      const delay = Math.random() * 0.3;
      const duration = 1 + Math.random();
      reactionEmoji.style.animationDelay = `${delay}s`;
      reactionEmoji.style.animationDuration = `${duration}s`;
  
      const angle = Math.random() * 360;
      const distance = Math.random() * 100 + 50;
      reactionEmoji.style.setProperty('--translate-x', `${Math.cos(angle * Math.PI / 180) * distance}px`);
      reactionEmoji.style.setProperty('--translate-y', `${Math.sin(angle * Math.PI / 180) * distance}px`);
  
      animationContainer.appendChild(reactionEmoji);
    }
  
    setTimeout(() => {
      animationContainer.remove();
    }, 2000);
  }
  